import {
  ChangeDetectionStrategy,
  Component,
  Injector,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import { BaseComponent } from "@shared/components/base.component";
import { ActivatedRoute } from "@angular/router";
import { ElasticsearchQueryService } from "@shared/services/elasticsearch-query.service";

@Component({
  selector: "app-persistent-linking",
  templateUrl: "./persistent-linking.component.html",
  styleUrls: ["./persistent-linking.component.scss"],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersistentLinkingComponent
  extends BaseComponent
  implements OnInit, OnDestroy
{
  parameters: any;

  constructor(
    private injector: Injector,
    private route: ActivatedRoute,
    private searchFiltersService: ElasticsearchQueryService
  ) {
    super(injector);
  }

  ngOnInit() {
    super.ngOnInit();
    this.fetchRecord();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  fetchRecord() {
    // http://localhost:4200/persistent-linking?assessment=20000000001
    // http://localhost:4200/persistent-linking?publication=A001
    // http://localhost:4200/persistent-linking?drill-hole=20000000002
    // http://localhost:4200/persistent-linking?mineral-inventory=MDI000000000098

    this.route.queryParamMap.subscribe((params) => {
      this.parameters = { ...params.keys, ...params };

      if(this.parameters.params != '{}') {
        var index = Object.keys(this.parameters.params);
        var id = this.parameters.params[index[0]];
        this.searchFiltersService.getPersistentRecord(index[0], id);
      }
    });
    
  }

}
